// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -------------------------------------------------------------------------- */
/* Large metric cards (.widget) — dashboard, premium tier, charts wrapper     */
/* -------------------------------------------------------------------------- */

.widget {
    position: relative;
    overflow: hidden;
    min-height: 200px;
    height: 100%;
    margin: 20px 0;
    padding: 24px 22px 26px;
    text-align: center;
    text-decoration: none;
    color: rgba(197, 197, 197, 0.95);
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: linear-gradient(
        165deg,
        rgba(58, 58, 58, 0.92) 0%,
        rgba(40, 40, 40, 0.96) 50%,
        rgba(34, 34, 34, 1) 100%
    );
    box-shadow:
        0 8px 32px rgba(0, 0, 0, 0.24),
        inset 0 1px 0 rgba(255, 255, 255, 0.04);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    transition:
        border-color 0.2s ease,
        box-shadow 0.2s ease,
        transform 0.2s ease;
}

.chart-card {
    padding: 14px 16px 16px;
    border-radius: 14px;
    min-height: 200px;
    height: 100%;
}

.widget::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(
        90deg,
        rgba(192, 159, 83, 0.2),
        rgba(192, 159, 83, 0.75),
        rgba(192, 159, 83, 0.2)
    );
    pointer-events: none;
}

.widget:hover {
    border-color: rgba(255, 255, 255, 0.12);
    box-shadow:
        0 14px 44px rgba(0, 0, 0, 0.3),
        inset 0 1px 0 rgba(255, 255, 255, 0.06);
}

a.widget:hover {
    transform: translateY(-2px);
}

.widget.overviewTotal::before {
    height: 4px;
    background: linear-gradient(
        90deg,
        rgba(192, 159, 83, 0.35),
        rgba(218, 190, 120, 0.95),
        rgba(192, 159, 83, 0.35)
    );
}

.widget .overvieTotal-num {
    margin: 0;
    margin-block-start: 0;
    font-size: clamp(1.85rem, 4.2vw, 2.75rem);
    font-weight: 600;
    line-height: 1.12;
    letter-spacing: -0.03em;
    color: rgb(245, 245, 245);
}

.widget > p {
    margin: 0;
    max-width: 22ch;
    font-size: 0.72rem;
    font-weight: 600;
    line-height: 1.4;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.38);
}

.widget .small-widget-percentage {
    display: block;
    margin-top: 6px;
    font-size: 0.8rem;
    font-weight: 500;
    letter-spacing: 0.02em;
    text-transform: none;
    color: rgba(192, 159, 83, 0.85);
}

/* Large widget + Line chart: stretch layout and summary strip */
.widget.widget--with-chart {
    align-items: stretch;
    min-height: 280px;
    text-align: left;
}

.widget.widget--with-chart > .overvieTotal-num,
.widget.widget--with-chart > p:first-of-type {
    text-align: center;
    align-self: center;
    width: 100%;
}

.widget.widget--with-chart > p:not(.widget__period):not(.widget__insight-label):not(.widget__insight-sub) {
    text-align: center;
    align-self: center;
}

.widget__period {
    margin: 2px 0 0 0;
    width: 100%;
    text-align: center;
    font-size: 0.75rem;
    font-weight: 500;
    letter-spacing: 0.04em;
    color: rgba(255, 255, 255, 0.35);
    text-transform: none;
}

.widget__insights {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px 14px;
    margin: 8px 0 4px;
    padding: 10px 8px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.06);
}

.widget__insight {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 5.5rem;
    padding: 4px 8px;
}

.widget__insight-label {
    font-size: 0.62rem;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.38);
}

.widget__insight-value {
    margin-top: 4px;
    font-size: 1rem;
    font-weight: 600;
    color: rgb(240, 240, 240);
    line-height: 1.2;
}

.widget__insight-sub {
    margin-top: 2px;
    font-size: 0.68rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.42);
    text-transform: none;
    letter-spacing: 0.02em;
}

.widget__insight--trend .widget__insight-value {
    font-size: 1.05rem;
}

.widget__insight--up .widget__insight-value {
    color: rgba(129, 214, 156, 0.95);
}

.widget__insight--down .widget__insight-value {
    color: rgba(241, 148, 138, 0.95);
}

.widget__chart-wrap {
    flex: 1;
    width: 100%;
    min-height: 200px;
    margin-top: 6px;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(0, 0, 0, 0.15);
}

.widget__chart-wrap .chart {
    min-height: 200px;
}

.no-padding {
    padding: 0;
}

.no-padding::before {
    display: none;
}

.span-2 {
    grid-column: span 2;
}

/* -------------------------------------------------------------------------- */
/* Compact KPI tiles (.key-highlight-widget.small-widget)                      */
/* -------------------------------------------------------------------------- */

.key-highlight-widget.small-widget {
    position: relative;
    overflow: visible;
    min-height: auto;
    margin: 0;
    padding: 16px 16px 18px 18px;
    text-align: left;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: linear-gradient(
        180deg,
        rgba(52, 52, 52, 0.95) 0%,
        rgba(38, 38, 38, 0.98) 100%
    );
    box-shadow:
        0 4px 18px rgba(0, 0, 0, 0.2),
        inset 0 1px 0 rgba(255, 255, 255, 0.05);
    transition:
        border-color 0.2s ease,
        box-shadow 0.2s ease,
        transform 0.2s ease;
}

.key-highlight-widget.small-widget::after {
    content: "";
    position: absolute;
    left: 0;
    top: 10px;
    bottom: 10px;
    width: 3px;
    border-radius: 0 4px 4px 0;
    background: linear-gradient(
        180deg,
        rgba(192, 159, 83, 0.15),
        rgba(192, 159, 83, 0.65),
        rgba(192, 159, 83, 0.15)
    );
    opacity: 0.35;
    pointer-events: none;
    transition: opacity 0.2s ease;
}

.key-highlight-widget.small-widget:hover {
    border-color: rgba(255, 255, 255, 0.14);
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.28);
}

.key-highlight-widget.small-widget:hover::after {
    opacity: 0.85;
}

.key-highlight-widget.small-widget.kpi::after {
    opacity: 1;
}

.key-highlight-widget .small-widget-type {
    margin: 0;
    font-size: 0.68rem;
    font-weight: 600;
    line-height: 1.35;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.42);
}

.key-highlight-widget .small-widget-number {
    margin: 10px 0 0 0;
    font-size: clamp(1.35rem, 2.5vw, 1.85rem);
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: -0.02em;
    color: rgb(238, 238, 238);
}

.key-highlight-widget .small-widget-percentage {
    display: inline-block;
    margin-top: 6px;
    font-size: 0.78rem;
    font-weight: 500;
    line-height: 1.4;
    color: rgba(255, 255, 255, 0.45);
}

.has-explainer {
    cursor: help;
    text-decoration: underline;
    text-decoration-style: dotted;
    text-underline-offset: 3px;
}

.explainer-tooltip {
    position: absolute;
    top: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    z-index: 50;
    width: min(280px, 86vw);
    padding: 12px 14px;
    font-size: 0.8125rem;
    font-weight: 400;
    line-height: 1.45;
    text-align: left;
    color: rgba(255, 255, 255, 0.95);
    background: rgba(22, 22, 22, 0.96);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 10px;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
}

.explainer-tooltip-text {
    display: block;
}

.explainer-tooltip-icon {
    font-weight: bold;
    margin-right: 5px;
    border: 1px solid #fff;
    border-radius: 50%;
    width: 14px;
    height: 14px;
    display: inline-block;
    text-align: center;
    line-height: 12px;
}

/* Sentiment / KPI emphasis (soft tint + readable text) */
.key-highlight-widget.small-widget.positive {
    border-color: rgba(46, 204, 113, 0.35);
    background: linear-gradient(
        135deg,
        rgba(46, 204, 113, 0.12) 0%,
        rgba(38, 42, 40, 0.98) 42%,
        rgba(36, 36, 36, 1) 100%
    );
}

.key-highlight-widget.small-widget.positive::after {
    background: linear-gradient(180deg, #2ecc71, #27ae60);
    opacity: 0.9;
}

.key-highlight-widget.small-widget.neutral {
    border-color: rgba(241, 196, 15, 0.4);
    background: linear-gradient(
        135deg,
        rgba(241, 196, 15, 0.14) 0%,
        rgba(44, 40, 32, 0.98) 42%,
        rgba(36, 36, 34, 1) 100%
    );
}

.key-highlight-widget.small-widget.neutral::after {
    background: linear-gradient(180deg, #f1c40f, #d4ac0d);
    opacity: 0.9;
}

.key-highlight-widget.small-widget.negative {
    border-color: rgba(231, 76, 60, 0.4);
    background: linear-gradient(
        135deg,
        rgba(231, 76, 60, 0.12) 0%,
        rgba(42, 34, 34, 0.98) 42%,
        rgba(38, 32, 32, 1) 100%
    );
}

.key-highlight-widget.small-widget.negative::after {
    background: linear-gradient(180deg, #e74c3c, #c0392b);
    opacity: 0.9;
}

.key-highlight-widget.small-widget.positive .small-widget-number,
.key-highlight-widget.small-widget.neutral .small-widget-number,
.key-highlight-widget.small-widget.negative .small-widget-number {
    color: rgb(252, 252, 252);
}

.key-highlight-widget.small-widget.positive .small-widget-percentage,
.key-highlight-widget.small-widget.neutral .small-widget-percentage,
.key-highlight-widget.small-widget.negative .small-widget-percentage {
    color: rgba(255, 255, 255, 0.75);
}

.key-highlight-widget.small-widget.positive .small-widget-type,
.key-highlight-widget.small-widget.neutral .small-widget-type,
.key-highlight-widget.small-widget.negative .small-widget-type {
    color: rgba(255, 255, 255, 0.72);
}

/* Loading placeholder tiles */
.key-highlight-widget.loading-small-widget {
    min-height: 88px;
    pointer-events: none;
}

.key-highlight-widget.loading-small-widget::after {
    opacity: 0.2;
}

/* Period comparison under small KPI values */
.small-widget-comparison {
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-top: 6px;
    font-size: 0.75rem;
    line-height: 1.35;
    color: rgba(200, 200, 205, 0.95);
}

.small-widget-comparison__line {
    font-weight: 600;
}

.small-widget-comparison__line.is-up {
    color: rgba(120, 200, 140, 0.95);
}

.small-widget-comparison__line.is-down {
    color: rgba(255, 120, 120, 0.9);
}

.small-widget-comparison__line.is-flat {
    color: rgba(200, 200, 205, 0.85);
}

.small-widget-comparison__line--rel {
    font-weight: 500;
    font-size: 0.7rem;
    opacity: 0.92;
}

/* Inline comparison chips under large chart */
.widget__comparison-inline {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 10px;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.widget__comparison-chip {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    padding: 6px 10px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.08);
}

.widget__comparison-chip-label {
    font-size: 0.6875rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: rgba(192, 159, 83, 0.95);
}

.widget__comparison-chip-metric {
    font-size: 0.8125rem;
    font-weight: 600;
    color: rgba(230, 230, 232, 0.98);
}

.widget__comparison-chip-metric.is-up {
    color: rgba(120, 200, 140, 0.98);
}

.widget__comparison-chip-metric.is-down {
    color: rgba(255, 120, 120, 0.95);
}

.widget__comparison-chip-metric.is-flat {
    color: rgba(200, 200, 205, 0.9);
}

.widget__comparison-chip-metric--rel {
    margin-top: 1px;
    font-size: 0.75rem;
    font-weight: 500;
    color: rgba(180, 180, 185, 0.92);
}
`, "",{"version":3,"sources":["webpack://./src/Components/widget/Widget.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E,+EAA+E;AAC/E,+EAA+E;;AAE/E;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;IACrB,gCAAgC;IAChC,mBAAmB;IACnB,2CAA2C;IAC3C;;;;;KAKC;IACD;;+CAE2C;IAC3C,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT;;;2BAGuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX;;;;;KAKC;IACD,oBAAoB;AACxB;;AAEA;IACI,uCAAuC;IACvC;;+CAE2C;AAC/C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX;;;;;KAKC;AACL;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,yCAAyC;IACzC,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;IACpB,+BAA+B;AACnC;;AAEA,gEAAgE;AAChE;IACI,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;IAC9B,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,OAAO;IACP,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,+EAA+E;AAC/E,gFAAgF;AAChF,+EAA+E;;AAE/E;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;IAC1C;;;;KAIC;IACD;;+CAE2C;IAC3C;;;2BAGuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,YAAY;IACZ,UAAU;IACV,0BAA0B;IAC1B;;;;;KAKC;IACD,aAAa;IACb,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,uCAAuC;IACvC,0CAA0C;AAC9C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,kCAAkC;IAClC,2CAA2C;IAC3C,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,yDAAyD;AACzD;IACI,sCAAsC;IACtC;;;;;KAKC;AACL;;AAEA;IACI,qDAAqD;IACrD,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC;;;;;KAKC;AACL;;AAEA;IACI,qDAAqD;IACrD,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC;;;;;KAKC;AACL;;AAEA;IACI,qDAAqD;IACrD,YAAY;AAChB;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;;;IAGI,gCAAgC;AACpC;;AAEA;;;IAGI,gCAAgC;AACpC;;AAEA,8BAA8B;AAC9B;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA,6CAA6C;AAC7C;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;AAEA,8CAA8C;AAC9C;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,2CAA2C;AAC/C;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC","sourcesContent":["/* -------------------------------------------------------------------------- */\n/* Large metric cards (.widget) — dashboard, premium tier, charts wrapper     */\n/* -------------------------------------------------------------------------- */\n\n.widget {\n    position: relative;\n    overflow: hidden;\n    min-height: 200px;\n    height: 100%;\n    margin: 20px 0;\n    padding: 24px 22px 26px;\n    text-align: center;\n    text-decoration: none;\n    color: rgba(197, 197, 197, 0.95);\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: linear-gradient(\n        165deg,\n        rgba(58, 58, 58, 0.92) 0%,\n        rgba(40, 40, 40, 0.96) 50%,\n        rgba(34, 34, 34, 1) 100%\n    );\n    box-shadow:\n        0 8px 32px rgba(0, 0, 0, 0.24),\n        inset 0 1px 0 rgba(255, 255, 255, 0.04);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    transition:\n        border-color 0.2s ease,\n        box-shadow 0.2s ease,\n        transform 0.2s ease;\n}\n\n.chart-card {\n    padding: 14px 16px 16px;\n    border-radius: 14px;\n    min-height: 200px;\n    height: 100%;\n}\n\n.widget::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 3px;\n    background: linear-gradient(\n        90deg,\n        rgba(192, 159, 83, 0.2),\n        rgba(192, 159, 83, 0.75),\n        rgba(192, 159, 83, 0.2)\n    );\n    pointer-events: none;\n}\n\n.widget:hover {\n    border-color: rgba(255, 255, 255, 0.12);\n    box-shadow:\n        0 14px 44px rgba(0, 0, 0, 0.3),\n        inset 0 1px 0 rgba(255, 255, 255, 0.06);\n}\n\na.widget:hover {\n    transform: translateY(-2px);\n}\n\n.widget.overviewTotal::before {\n    height: 4px;\n    background: linear-gradient(\n        90deg,\n        rgba(192, 159, 83, 0.35),\n        rgba(218, 190, 120, 0.95),\n        rgba(192, 159, 83, 0.35)\n    );\n}\n\n.widget .overvieTotal-num {\n    margin: 0;\n    margin-block-start: 0;\n    font-size: clamp(1.85rem, 4.2vw, 2.75rem);\n    font-weight: 600;\n    line-height: 1.12;\n    letter-spacing: -0.03em;\n    color: rgb(245, 245, 245);\n}\n\n.widget > p {\n    margin: 0;\n    max-width: 22ch;\n    font-size: 0.72rem;\n    font-weight: 600;\n    line-height: 1.4;\n    letter-spacing: 0.12em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.38);\n}\n\n.widget .small-widget-percentage {\n    display: block;\n    margin-top: 6px;\n    font-size: 0.8rem;\n    font-weight: 500;\n    letter-spacing: 0.02em;\n    text-transform: none;\n    color: rgba(192, 159, 83, 0.85);\n}\n\n/* Large widget + Line chart: stretch layout and summary strip */\n.widget.widget--with-chart {\n    align-items: stretch;\n    min-height: 280px;\n    text-align: left;\n}\n\n.widget.widget--with-chart > .overvieTotal-num,\n.widget.widget--with-chart > p:first-of-type {\n    text-align: center;\n    align-self: center;\n    width: 100%;\n}\n\n.widget.widget--with-chart > p:not(.widget__period):not(.widget__insight-label):not(.widget__insight-sub) {\n    text-align: center;\n    align-self: center;\n}\n\n.widget__period {\n    margin: 2px 0 0 0;\n    width: 100%;\n    text-align: center;\n    font-size: 0.75rem;\n    font-weight: 500;\n    letter-spacing: 0.04em;\n    color: rgba(255, 255, 255, 0.35);\n    text-transform: none;\n}\n\n.widget__insights {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 10px 14px;\n    margin: 8px 0 4px;\n    padding: 10px 8px;\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.2);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.widget__insight {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    min-width: 5.5rem;\n    padding: 4px 8px;\n}\n\n.widget__insight-label {\n    font-size: 0.62rem;\n    font-weight: 600;\n    letter-spacing: 0.12em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.38);\n}\n\n.widget__insight-value {\n    margin-top: 4px;\n    font-size: 1rem;\n    font-weight: 600;\n    color: rgb(240, 240, 240);\n    line-height: 1.2;\n}\n\n.widget__insight-sub {\n    margin-top: 2px;\n    font-size: 0.68rem;\n    font-weight: 500;\n    color: rgba(255, 255, 255, 0.42);\n    text-transform: none;\n    letter-spacing: 0.02em;\n}\n\n.widget__insight--trend .widget__insight-value {\n    font-size: 1.05rem;\n}\n\n.widget__insight--up .widget__insight-value {\n    color: rgba(129, 214, 156, 0.95);\n}\n\n.widget__insight--down .widget__insight-value {\n    color: rgba(241, 148, 138, 0.95);\n}\n\n.widget__chart-wrap {\n    flex: 1;\n    width: 100%;\n    min-height: 200px;\n    margin-top: 6px;\n    border-radius: 10px;\n    overflow: hidden;\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    background: rgba(0, 0, 0, 0.15);\n}\n\n.widget__chart-wrap .chart {\n    min-height: 200px;\n}\n\n.no-padding {\n    padding: 0;\n}\n\n.no-padding::before {\n    display: none;\n}\n\n.span-2 {\n    grid-column: span 2;\n}\n\n/* -------------------------------------------------------------------------- */\n/* Compact KPI tiles (.key-highlight-widget.small-widget)                      */\n/* -------------------------------------------------------------------------- */\n\n.key-highlight-widget.small-widget {\n    position: relative;\n    overflow: visible;\n    min-height: auto;\n    margin: 0;\n    padding: 16px 16px 18px 18px;\n    text-align: left;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    background: linear-gradient(\n        180deg,\n        rgba(52, 52, 52, 0.95) 0%,\n        rgba(38, 38, 38, 0.98) 100%\n    );\n    box-shadow:\n        0 4px 18px rgba(0, 0, 0, 0.2),\n        inset 0 1px 0 rgba(255, 255, 255, 0.05);\n    transition:\n        border-color 0.2s ease,\n        box-shadow 0.2s ease,\n        transform 0.2s ease;\n}\n\n.key-highlight-widget.small-widget::after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 10px;\n    bottom: 10px;\n    width: 3px;\n    border-radius: 0 4px 4px 0;\n    background: linear-gradient(\n        180deg,\n        rgba(192, 159, 83, 0.15),\n        rgba(192, 159, 83, 0.65),\n        rgba(192, 159, 83, 0.15)\n    );\n    opacity: 0.35;\n    pointer-events: none;\n    transition: opacity 0.2s ease;\n}\n\n.key-highlight-widget.small-widget:hover {\n    border-color: rgba(255, 255, 255, 0.14);\n    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.28);\n}\n\n.key-highlight-widget.small-widget:hover::after {\n    opacity: 0.85;\n}\n\n.key-highlight-widget.small-widget.kpi::after {\n    opacity: 1;\n}\n\n.key-highlight-widget .small-widget-type {\n    margin: 0;\n    font-size: 0.68rem;\n    font-weight: 600;\n    line-height: 1.35;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.42);\n}\n\n.key-highlight-widget .small-widget-number {\n    margin: 10px 0 0 0;\n    font-size: clamp(1.35rem, 2.5vw, 1.85rem);\n    font-weight: 600;\n    line-height: 1.2;\n    letter-spacing: -0.02em;\n    color: rgb(238, 238, 238);\n}\n\n.key-highlight-widget .small-widget-percentage {\n    display: inline-block;\n    margin-top: 6px;\n    font-size: 0.78rem;\n    font-weight: 500;\n    line-height: 1.4;\n    color: rgba(255, 255, 255, 0.45);\n}\n\n.has-explainer {\n    cursor: help;\n    text-decoration: underline;\n    text-decoration-style: dotted;\n    text-underline-offset: 3px;\n}\n\n.explainer-tooltip {\n    position: absolute;\n    top: calc(100% + 8px);\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 50;\n    width: min(280px, 86vw);\n    padding: 12px 14px;\n    font-size: 0.8125rem;\n    font-weight: 400;\n    line-height: 1.45;\n    text-align: left;\n    color: rgba(255, 255, 255, 0.95);\n    background: rgba(22, 22, 22, 0.96);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 10px;\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);\n}\n\n.explainer-tooltip-text {\n    display: block;\n}\n\n.explainer-tooltip-icon {\n    font-weight: bold;\n    margin-right: 5px;\n    border: 1px solid #fff;\n    border-radius: 50%;\n    width: 14px;\n    height: 14px;\n    display: inline-block;\n    text-align: center;\n    line-height: 12px;\n}\n\n/* Sentiment / KPI emphasis (soft tint + readable text) */\n.key-highlight-widget.small-widget.positive {\n    border-color: rgba(46, 204, 113, 0.35);\n    background: linear-gradient(\n        135deg,\n        rgba(46, 204, 113, 0.12) 0%,\n        rgba(38, 42, 40, 0.98) 42%,\n        rgba(36, 36, 36, 1) 100%\n    );\n}\n\n.key-highlight-widget.small-widget.positive::after {\n    background: linear-gradient(180deg, #2ecc71, #27ae60);\n    opacity: 0.9;\n}\n\n.key-highlight-widget.small-widget.neutral {\n    border-color: rgba(241, 196, 15, 0.4);\n    background: linear-gradient(\n        135deg,\n        rgba(241, 196, 15, 0.14) 0%,\n        rgba(44, 40, 32, 0.98) 42%,\n        rgba(36, 36, 34, 1) 100%\n    );\n}\n\n.key-highlight-widget.small-widget.neutral::after {\n    background: linear-gradient(180deg, #f1c40f, #d4ac0d);\n    opacity: 0.9;\n}\n\n.key-highlight-widget.small-widget.negative {\n    border-color: rgba(231, 76, 60, 0.4);\n    background: linear-gradient(\n        135deg,\n        rgba(231, 76, 60, 0.12) 0%,\n        rgba(42, 34, 34, 0.98) 42%,\n        rgba(38, 32, 32, 1) 100%\n    );\n}\n\n.key-highlight-widget.small-widget.negative::after {\n    background: linear-gradient(180deg, #e74c3c, #c0392b);\n    opacity: 0.9;\n}\n\n.key-highlight-widget.small-widget.positive .small-widget-number,\n.key-highlight-widget.small-widget.neutral .small-widget-number,\n.key-highlight-widget.small-widget.negative .small-widget-number {\n    color: rgb(252, 252, 252);\n}\n\n.key-highlight-widget.small-widget.positive .small-widget-percentage,\n.key-highlight-widget.small-widget.neutral .small-widget-percentage,\n.key-highlight-widget.small-widget.negative .small-widget-percentage {\n    color: rgba(255, 255, 255, 0.75);\n}\n\n.key-highlight-widget.small-widget.positive .small-widget-type,\n.key-highlight-widget.small-widget.neutral .small-widget-type,\n.key-highlight-widget.small-widget.negative .small-widget-type {\n    color: rgba(255, 255, 255, 0.72);\n}\n\n/* Loading placeholder tiles */\n.key-highlight-widget.loading-small-widget {\n    min-height: 88px;\n    pointer-events: none;\n}\n\n.key-highlight-widget.loading-small-widget::after {\n    opacity: 0.2;\n}\n\n/* Period comparison under small KPI values */\n.small-widget-comparison {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    margin-top: 6px;\n    font-size: 0.75rem;\n    line-height: 1.35;\n    color: rgba(200, 200, 205, 0.95);\n}\n\n.small-widget-comparison__line {\n    font-weight: 600;\n}\n\n.small-widget-comparison__line.is-up {\n    color: rgba(120, 200, 140, 0.95);\n}\n\n.small-widget-comparison__line.is-down {\n    color: rgba(255, 120, 120, 0.9);\n}\n\n.small-widget-comparison__line.is-flat {\n    color: rgba(200, 200, 205, 0.85);\n}\n\n.small-widget-comparison__line--rel {\n    font-weight: 500;\n    font-size: 0.7rem;\n    opacity: 0.92;\n}\n\n/* Inline comparison chips under large chart */\n.widget__comparison-inline {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px 10px;\n    margin-top: 10px;\n    padding-top: 10px;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.widget__comparison-chip {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n    padding: 6px 10px;\n    border-radius: 8px;\n    background: rgba(0, 0, 0, 0.2);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.widget__comparison-chip-label {\n    font-size: 0.6875rem;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n    color: rgba(192, 159, 83, 0.95);\n}\n\n.widget__comparison-chip-metric {\n    font-size: 0.8125rem;\n    font-weight: 600;\n    color: rgba(230, 230, 232, 0.98);\n}\n\n.widget__comparison-chip-metric.is-up {\n    color: rgba(120, 200, 140, 0.98);\n}\n\n.widget__comparison-chip-metric.is-down {\n    color: rgba(255, 120, 120, 0.95);\n}\n\n.widget__comparison-chip-metric.is-flat {\n    color: rgba(200, 200, 205, 0.9);\n}\n\n.widget__comparison-chip-metric--rel {\n    margin-top: 1px;\n    font-size: 0.75rem;\n    font-weight: 500;\n    color: rgba(180, 180, 185, 0.92);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
